export const boardVisibilityTypes = {
  VISIBLE: {
    value: 'VISIBLE',
    badge: 'success',
    label: 'BoardLabelVisible',
  },
  NOT_VISIBLE: {
    value: 'NOT_VISIBLE',
    badge: 'danger',
    label: 'BoardLabelNotVisible',
  },
};
